import { FundraiserSearchFilter } from 'src/modules/fundraiser/models/fundraiserSearchFilter';
import { FundraiserResponse } from 'src/modules/fundraiser/models/fundraiserResponse';
import { FundraiserPaymentDistributionResponse } from 'src/modules/fundraiser/models/fundraiserPaymentDistributionResponse';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'Fundraiser';

export const getAllFundraiser = (searchFilter: FundraiserSearchFilter) => {
  return AxiosInstance.get<PagedResult<FundraiserResponse>>(controller, { params: searchFilter });
};

export const getFundraiserById = (id: string | undefined) => {
  return AxiosInstance.get<FundraiserResponse>(`${controller}/${id}`);
};

export const updateFundraiserAutogiroReminderSettings = (
  id: number,
  data: {
    autogiroRemindersEnabled: boolean;
    autogiroReminder1Subject: string;
    autogiroReminder1Body: string;
    autogiroReminder2Subject: string;
    autogiroReminder2Body: string;
  },
) => {
  return AxiosInstance.put(`${controller}/${id}/AutogiroReminderSettings`, data);
};

export const getFundraiserPaymentDistribution = (fundraiserId: number, startDate?: string, endDate?: string) => {
  return AxiosInstance.get<FundraiserPaymentDistributionResponse>(`${controller}/PaymentDistribution`, {
    params: {
      fundraiserId,
      startDate,
      endDate,
    },
  });
};

// Gåvobladsfiler

export interface GiftCertificateFileResponse {
  fileName: string;
  fileType: string; // "background" (bakgrund), "motif" (motiv), "logo"
  url: string;
  fileSize: number;
  lastModified: string;
}

export interface GiftCertificateFilesResponse {
  type: string; // "celebration" | "memorial"
  fundraiserId: number | null; // Satt om fundraiser-specifika filer används
  backgrounds: GiftCertificateFileResponse[];
  motifs: GiftCertificateFileResponse[];
  logo: GiftCertificateFileResponse | null;
  maxMotifs: number;
}

export const getGiftCertificateFiles = (fundraiserId: number) => {
  return AxiosInstance.get<GiftCertificateFilesResponse>(`${controller}/${fundraiserId}/GiftCertificateFiles`);
};

export const uploadGiftCertificateFile = (fundraiserId: number, fileType: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return AxiosInstance.post<GiftCertificateFileResponse>(`${controller}/${fundraiserId}/GiftCertificateFiles/${fileType}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteGiftCertificateFile = (fundraiserId: number, fileName: string) => {
  return AxiosInstance.delete(`${controller}/${fundraiserId}/GiftCertificateFiles/${fileName}`);
};

export interface GiftCertificateSuggestionResponse {
  fileName: string;
  base64: string;
}

export const getGiftCertificateSuggestions = () => {
  return AxiosInstance.get<GiftCertificateSuggestionResponse[]>(`${controller}/GiftCertificateSuggestions`);
};
